import type { Moment } from 'moment';
import { useSelector } from 'react-redux';

import { getCreatedAt } from '@wecasa/common/src/utils/booking';
import { FORMATS, formatDate } from '@wecasa/common/src/utils/date';

import { getBasketMode } from '../ducks/basket';
import { getModifiedBooking } from '../ducks/basket-selectors';

const formatDateForAPI = (date: Moment) => formatDate(date, FORMATS.DATETIME.TIMESTAMPS);

export const useVersionedAt = () => {
  const mode = useSelector(getBasketMode);
  const modificationBooking = useSelector(getModifiedBooking);

  return mode === 'modification' && modificationBooking
    ? formatDateForAPI(getCreatedAt(modificationBooking))
    : undefined;
};
